module.exports = __webpack_public_path__ + "static/media/moniya-railway-icon.f0babc95.svg";